<template>
    <div>
        <v-dialog v-model="dialog" :persistent="edit_variation_loading" max-width="900" content-class="rounded-xl">
            <v-card v-if="product">
                <v-card-title>
                    Επεξεργασία Παραλλαγής του {{ product.name }}
                    <v-spacer></v-spacer>
                    <v-btn icon :disabled="edit_variation_loading" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form v-model="edit_variation_form" :disabled="edit_variation_loading">
                        <v-container fluid>
                            <v-layout row>
                                <v-flex xs10 md11>
                                    <v-overflow-btn editable v-model="edit_variation.size" :items="attr_size_options" :loading="!attr_size_options" item-value="name" item-text="name" rounded filled label="Μέγεθος" :rules="[ v => !!v || 'Απαιτείται συμπλήρωση' ]"></v-overflow-btn>
                                </v-flex>
                                <v-flex xs2 md1 class="center-all">
                                    <v-btn icon @click="add_size_dialog = true" class="mb-6" :disabled="attributes_loading"><v-icon>mdi-plus</v-icon></v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>

                        <v-container fluid>
                            <v-layout row>
                                <v-flex xs10 md11>
                                    <v-overflow-btn editable v-model="edit_variation.color" :items="attr_color_options" :loading="!attr_color_options" item-value="name" item-text="name" rounded filled label="Χρώμα" :rules="[ v => !!v || 'Απαιτείται συμπλήρωση' ]"></v-overflow-btn>
                                </v-flex>
                                <v-flex xs2 md1 class="center-all">
                                    <v-btn icon @click="add_color_dialog = true" class="mb-6" :disabled="attributes_loading"><v-icon>mdi-plus</v-icon></v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        <v-text-field v-model="edit_variation.price" rounded filled dense label="Τιμή" :rules="[ v => !!v || 'Απαιτείται συμπλήρωση' ]"></v-text-field>
                        <v-text-field v-model="edit_variation.quantity" rounded filled dense label="Ποσότητα" :rules="[ v => !!v || 'Απαιτείται συμπλήρωση' ]"></v-text-field>
                        <v-text-field v-model="edit_variation.sku" rounded filled dense label="Barcode"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn depressed rounded color="primary" :loading="edit_variation_loading" @click="editVariation()"><v-icon left>mdi-content-save</v-icon>Αποθήκευση</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

		<AddAttributeDialog v-if="attr_size && attr_size.id" v-model="add_size_dialog" attribute="size" :attr_id="attr_size.id" @reloadAttributes="loadWooAttributes()"></AddAttributeDialog>
		<AddAttributeDialog v-if="attr_color && attr_color.id" v-model="add_color_dialog" attribute="color" :attr_id="attr_color.id" @reloadAttributes="loadWooAttributes()"></AddAttributeDialog>
    </div>
</template>

<style scoped>
</style>

<script>
import AddAttributeDialog from '@/components/AddAttributeDialog'
export default {
    name: 'EditVariation',
    components: {
		AddAttributeDialog
    },
    props: {
        value: {
            type: Object,
            default: false
        },
        product: {
            type: Object,
            default: false
        }
    },
    data: () => ({
        categories: [],
        categories_loading: false,
        attributes: [],
        attributes_loading: false,

        edit_variation_form: true,
        edit_variation_loading: false,
        edit_variation: {
            size: null,
            color: null,
            price: null,
            quantity: null,
            sku: null
        },
        add_size_dialog: false,
        add_color_dialog: false
    }),
    computed: {
        dialog: {
            get () {
                return !!this.value
            },
            set (v) {
                if (!v) this.$emit('input', null)
            }
        },
        attr_color () {
			return this.attributes?.find(attr => attr.name.toLowerCase() == 'color')
		},
		attr_color_options () {
			return this.attr_color?.options?.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)) || []
		},
		attr_size () {
			return this.attributes?.find(attr => attr.name.toLowerCase() == 'size')
		},
		attr_size_options () {
			return this.attr_size?.options?.sort((a,b) => (a.name > b.name) ? -1 : ((b.name > a.name) ? 1 : 0)) || []
		}
    },
    watch: {
        dialog (v) {
            if (!v) return
            this.loadWooCategories()
            this.loadWooAttributes()
        },
        value: {
            handler (v) {
                if (!v) {
                    return this.edit_variation = {
                        size: null,
                        color: null,
                        price: null,
                        quantity: null,
                        sku: null
                    }
                }
                this.edit_variation.size = v.attributes?.find(attr => attr.name.toLowerCase() == 'size').option
                this.edit_variation.color = v.attributes?.find(attr => attr.name.toLowerCase() == 'color').option
                this.edit_variation.price = v.price
                this.edit_variation.quantity = v.stock_quantity
                this.edit_variation.sku = v.sku
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        loadWooCategories (page = 1) {
			if (!localStorage.getItem('wp_site_url') || !localStorage.getItem('wp_consumer_key') || !localStorage.getItem('wp_consumer_secret')) {
				return this.$store.state.error = new Error('Πρέπει να ρυθμίσετε πρώτα την σύνδεση με το WooCommerce.')
			}

            this.categories_loading = true

			let data = {
				url: localStorage.getItem('wp_site_url'),
				consumer_key: localStorage.getItem('wp_consumer_key'),
				consumer_secret: localStorage.getItem('wp_consumer_secret'),
				page
			}
			this.axios.post('store-categories', data)
				.then(resp => {
					if (page > 1) {
						this.categories = this.categories.concat(resp.data.categories)
					} else {
						this.categories = resp.data.categories
					}
                    this.categories_loading = false
					if (this.$flattenCategories(resp.data.categories).length > 99) this.loadWooCategories(page + 1)
					console.log('Store Categories loaded successfully.')
				})
				.catch(err => {
					this.$store.state.error = err
                    this.categories_loading = false
				})
		},
		loadWooAttributes () {
			if (!localStorage.getItem('wp_site_url') || !localStorage.getItem('wp_consumer_key') || !localStorage.getItem('wp_consumer_secret')) {
				return this.$store.state.error = new Error('Πρέπει να ρυθμίσετε πρώτα την σύνδεση με το WooCommerce.')
			}

            this.attributes_loading = true

			let data = {
				url: localStorage.getItem('wp_site_url'),
				consumer_key: localStorage.getItem('wp_consumer_key'),
				consumer_secret: localStorage.getItem('wp_consumer_secret')
			}
			this.axios.post('get-attributes', data)
				.then(resp => {
					this.attributes = resp.data.attributes
					console.log('Product Attributes loaded successfully.')
                    this.attributes_loading = false
				})
				.catch(err => {
					this.$store.state.error = err
                    this.attributes_loading = false
				})
		},
        editVariation () {
			if (!this.edit_variation_form) return this.$store.state.error = new Error('Πρέπει να συμπληρώσεις όλα τα απαραίτητα πεδία!')

			if (!localStorage.getItem('wp_site_url') || !localStorage.getItem('wp_consumer_key') || !localStorage.getItem('wp_consumer_secret')) {
				return this.$store.state.error = new Error('Πρέπει να ρυθμίσετε πρώτα την σύνδεση με το WooCommerce.')
			}

			this.edit_variation_loading = true

            let product_data = {
                regular_price: this.edit_variation.price,
                stock_quantity: this.edit_variation.quantity
            }

			product_data.stock_quantity = product_data.stock_quantity ? parseInt(product_data.stock_quantity) : 0
            if (this.edit_variation.sku != this.value.sku) product_data.sku = this.edit_variation.sku

            let attributes = []

			attributes.push({ // Color
				id: this.attr_color.id,
				name: this.attr_color.name,
				option: this.edit_variation.color
			})

			attributes.push({ // Size
				id: this.attr_size.id,
				name: this.attr_size.name,
				option: this.edit_variation.size
			})

            product_data.attributes = attributes

            let data = {
				url: localStorage.getItem('wp_site_url'),
				consumer_key: localStorage.getItem('wp_consumer_key'),
				consumer_secret: localStorage.getItem('wp_consumer_secret'),
                variation_id: this.value.id,
			    product_id: this.product.id,
				data: product_data
			}

            this.axios.post('update-variation', data)
				.then(resp => {
                    this.edit_variation_loading = false
                    this.dialog = false
                    this.edit_variation = {
                        size: null,
                        color: null,
                        price: null,
                        quantity: null,
                        sku: null
                    }
                    this.$emit('reload')
					// console.log(resp.data)
                })
				.catch(err => {
					this.$store.state.error = err
                    this.edit_variation_loading = false
				})
        }
    }
}
</script>